import { GET_UNIDADE_NOTICIAS } from '../../constants';

const initialState = {
  noticias: {
    error: null,
    data: {
      items: [],
      items_total: 0,
    },
    loaded: false,
    loading: false,
  },
};

export const getUnidadeDadosReducer = (
  state = initialState,
  action: any = {},
) => {
  switch (action.type) {
    case `${GET_UNIDADE_NOTICIAS}_PENDING`:
      return {
        ...state,
        noticias: {
          ...state.noticias,
          error: null,
          data: { items: [], items_total: 0 },
          loaded: false,
          loading: true,
        },
      };

    case `${GET_UNIDADE_NOTICIAS}_SUCCESS`:
      return {
        ...state,
        noticias: {
          ...state.noticias,
          error: null,
          data: action.result || { items: [], items_total: 0 },
          loaded: true,
          loading: false,
        },
      };

    case `${GET_UNIDADE_NOTICIAS}_FAIL`:
      return {
        ...state,
        noticias: {
          ...state.noticias,
          error: action.error,
          loaded: false,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default getUnidadeDadosReducer;
